import clsx from 'clsx';
import React from 'react';

const Badge = ({ children, className, ...props }) => (
  <div
    className={clsx(
      'inline-block font-bold self-center text-xs rounded py-[0.15em] px-2',
      className,
    )}
    {...props}
  >
    {children}
  </div>
);

export default Badge;
